<template>
  <div class="hero-pet-panel container">
    <div class="row" v-if="heros.length > 0">
      <hero-pet-card v-for="(hero, index) in heros" :key="index"
        :hero="hero"
        :showCta="true"/>
    </div>
    <spinning-loader class="spin-loader" size="80" v-if="isLoading"/>
    <div class="row mt-4 mb-5">
      <button type="button"
        v-if="haveNext && showLoadMore"
        class="mx-auto btn btn-outline-primary"
        style="width: 212px;height: 42px;"
        @click="fetchData">See More</button>
    </div>
  </div>
</template>

<script>
import SpinningLoader from '@/components/SpinningLoader.vue'
import HeroPetCard from '@/components/HeroPetCard.vue'

export default {
  name: 'HeroPetPanel',
  props: ['medal', 'showLoadMore'],
  components: {
    HeroPetCard,
    SpinningLoader
  },
  data () {
    return {
      perPage: 8,
      currentPage: 0,
      haveNext: true,
      isLoading: false,
      heros: []
    }
  },
  methods: {
    async fetchData () {
      if (!this.haveNext) return

      this.isLoading = true

      this.currentPage = this.currentPage + 1
      let query = 'medal=' + this.medal + '&page=' + this.currentPage
      this.$http.get('pet/heros/?' + query).then((response) => {
        this.heros = [...this.heros, ...response.data.result.results]
        this.haveNext = this.heros.length < response.data.result.count
      })

      this.isLoading = false
    }
  },
  async created () {
    this.fetchData()
  }
}
</script>

<style scoped lang="scss">
.spin-loader {
  margin: 1rem auto;
}
.card-enter-active, .card-leave-active {
  transition: all 1.5s;
}
.card-enter, .card-leave-to {
  opacity: 0;
}
</style>
